import React from 'react';

export default function GlassCard({ children, width='w-auto', height='h-auto', textColor='text-white', bgColor='bg-white/10', hoverBgColor='hover:bg-white/20', paddings='px-3', rounded='rounded-2xl', clickEffect=false, onClick }) {
  return (
    <div onClick={onClick} className={`${height} ${width} ${textColor} ${bgColor} ${hoverBgColor} ${paddings} ${rounded} flex justify-center border border-white/20 backdrop-blur-sm transition-all duration-300 after:pointer-events-none ${clickEffect && 'active:scale-95 active:bg-opacity-30 ease-in-out cursor-pointer'}`}>
      {children}
    </div>
  );
}
